// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2t0M8","container":"styles_container__1bo8r","title":"styles_title__3TsxE","wrapper":"styles_wrapper__3wglY","answer":"styles_answer__1Q61W"};